/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ termsLink: NonNullable<unknown>, privacyLink: NonNullable<unknown> }} Consent_Terms_Privacy_LabelInputs */

const en_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I have read and accept the ${i?.termsLink} and ${i?.privacyLink}.`)
};

const de_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich habe die ${i?.termsLink} und die ${i?.privacyLink} gelesen und akzeptiere diese.`)
};

const fr_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J'ai lu et j'accepte les ${i?.termsLink} et la ${i?.privacyLink}.`)
};

const es_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`He leido y acepto los ${i?.termsLink} y la ${i?.privacyLink}.`)
};

const it_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ho letto e accetto i ${i?.termsLink} e l'${i?.privacyLink}.`)
};

const nl_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ik heb de ${i?.termsLink} en het ${i?.privacyLink} gelezen en ga akkoord.`)
};

const pl_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Przeczytalam/em i akceptuje ${i?.termsLink} oraz ${i?.privacyLink}.`)
};

const fi_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olen lukenut ja hyvaksyn ${i?.termsLink} ja ${i?.privacyLink}.`)
};

const da_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jeg har laest og accepterer ${i?.termsLink} og ${i?.privacyLink}.`)
};

const sv_consent_terms_privacy_label = /** @type {(inputs: Consent_Terms_Privacy_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jag har last och accepterar ${i?.termsLink} och ${i?.privacyLink}.`)
};

/**
* | output |
* | --- |
* | "I have read and accept the {termsLink} and {privacyLink}." |
*
* @param {Consent_Terms_Privacy_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_terms_privacy_label = /** @type {((inputs: Consent_Terms_Privacy_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Terms_Privacy_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_terms_privacy_label(inputs)
	if (locale === "fr") return fr_consent_terms_privacy_label(inputs)
	if (locale === "es") return es_consent_terms_privacy_label(inputs)
	if (locale === "it") return it_consent_terms_privacy_label(inputs)
	if (locale === "nl") return nl_consent_terms_privacy_label(inputs)
	if (locale === "pl") return pl_consent_terms_privacy_label(inputs)
	if (locale === "fi") return fi_consent_terms_privacy_label(inputs)
	if (locale === "da") return da_consent_terms_privacy_label(inputs)
	if (locale === "sv") return sv_consent_terms_privacy_label(inputs)
	return en_consent_terms_privacy_label(inputs)
});